import filtros from "./filtros";
import projetos from "./projetos";
import paginacao from "./paginacao";

export default {
  namespaced: true,
  modules: {
    filtros,
    projetos,
    paginacao
  }
};
